import React, { Component } from 'react';
import kwootLogoBlack from '../kwoot/logo-black.svg';

import './frontpageanimation.css';

class Frontpageanimation extends Component {
    render() {
        return (
            <div className="frontpageanimation">
                <div className="frontpageanimation__eyes"></div>
                <div className="frontpageanimation__telephones"></div>
                <div className="frontpageanimation__referenceframe">
                    <div className="frontpageanimation__blackbox"></div>
                    <div className="frontpageanimation__frame"></div>
                    <div className="frontpageanimation__textkijk"></div>
                    <div className="frontpageanimation__image"></div>
                    <div className="frontpageanimation__textmetandereogen"></div>
                    <img className="frontpageanimation__logo" role="presentation" src={kwootLogoBlack}/>
                </div>

            </div>
        );
    }
}

export default Frontpageanimation;



// WEBPACK FOOTER //
// ./src/components/frontpageanimation/frontpageanimation.js